export function getProperty(obj: any, path: string): any {
  var properties = path.split('.');
  var index = 0;
  var recurse = (obj: any, parent) => {
    if (obj == null) return null;
    if (index == properties.length) {
      return typeof obj == 'function' ? parent[properties[index - 1]]() : obj;
    }
    return typeof obj == 'function'
      ? recurse(parent[properties[index - 1]]()[properties[index]], parent[properties[index++ - 1]]())
      : recurse(obj[properties[index++]], obj);
  };
  return recurse(obj[properties[index++]], obj);
}
